import styled from 'styled-components'

export const StyledModalContent = styled.div`
  display: flex;
  padding: 0 24px 24px;
  input {
    flex: 1;
  }
` as any

const StyledPreviewContainer = styled.div`
  height: 150px;
  width: 150px;
  min-height: 150px;
  min-width: 150px;
  margin-right: 24px;
` as any

export const StyledThumbnail = styled(StyledPreviewContainer)`
  background-image: url(${(props: any) => props.src});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: top;
  display: flex;
  align-items: center;
  > div {
    margin: 0 auto;
  }
` as any

export const FlexibleWrapper = styled.div`
  flex-grow: 1;
`

export const StyledFileNameWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 0.5em;
  .file-name {
    font-weight: 700;
  }
`
